export default function CaracteristiquesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('caracteristiques');
}

CaracteristiquesConfiguration.$inject = ['$translatePartialLoaderProvider'];
